import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import './index.css';
import App from './App';
import { msalConfig } from './authConfig';
import { resolveActiveAccount, setActiveAccountFromResult } from './utils/authSession';

// Suppress benign ResizeObserver loop errors by patching the observer itself.
// The window error listener approach doesn't work because React/Webpack dev overlay
// intercepts the error before the listener fires. Wrapping the callback in
// requestAnimationFrame prevents the "loop completed" error from being thrown.
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
        super((entries, observer) => {
            window.requestAnimationFrame(() => {
                try { callback(entries, observer); } catch (e) { /* suppress */ }
            });
        });
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(async () => {
  msalInstance.enableAccountStorageEvents();

  try {
    const response = await msalInstance.handleRedirectPromise();
    if (response) {
      setActiveAccountFromResult(msalInstance, response);
    } else {
      resolveActiveAccount(msalInstance);
    }
  } catch (error) {
    console.error(error);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App instance={msalInstance} />
    </React.StrictMode>
  );
});
